export const BidManageRouting = [
  {
    path: "/tender/bid-manage/list",
    name: "tender-bid-manage-list",
    meta: { title: "开标管理" },
    component: () =>
      import(
        /* webpackChunkName: "tender-bid-manage" */ "@/views/tender/bid-manage/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/tender/bid-manage/create",
    name: "tender-bid-manage-create",
    meta: { title: "开标登记", comName: "TenderBidManageCreateForm" },
    component: () =>
      import(
        /* webpackChunkName: "tender-bid-manage" */ "@/views/tender/bid-manage/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/tender/bid-manage/edit/:id",
    name: "tender-bid-manage-edit",
    meta: { title: "编辑开标记录", comName: "TenderBidManageCreateForm" },
    component: () =>
      import(
        /* webpackChunkName: "tender-bid-manage" */ "@/views/tender/bid-manage/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/tender/bid-manage/detail/:id",
    name: "tender-bid-manage-detail",
    meta: { title: "开标详情" },
    component: () =>
      import(
        /* webpackChunkName: "tender-bid-manage" */ "@/views/tender/bid-manage/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/tender/bid-manage/flowPrint/:id",
    name: "tender-bid-manage-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "tender-quote" */ "@/views/tender/bid-manage/flow-print/index.vue"
      ),
  },
];
